import { TYPE_STRING } from './input-types';

export const id = 'recipientName';
export const apiKey = 'ShipToName';
export const type = TYPE_STRING;

export const recipientName = {
  id,
  apiKey,
  type,
};
